import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { Button, ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { APPLICATION_MODE_NEW, ROUTE_PATH } from "../../../app/constants";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";

export const WorkExperienceConfirmationView = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const mainAgentString = isPrincipalBroker ? 'principal broker' : 'compliance officer'
  const [showRoleConfirmationError, setShowRoleConfirmationError] = useState(false);

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;

  const title = `Work experience requirement`;
  const errStr = `The ${mainAgentString} must meet at least one of these criteria.`;

  const handleNext = (confirmDuty) => () => {
    setShowRoleConfirmationError(!confirmDuty);
    
    if(confirmDuty) {
      dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_RESIDENCY_CONFIRMATION}`));
      return;
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props}
          hideSaveAndExit 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      <div className="row topMarginNormal">
        <div className="col-lg-8">
            <p>
                {`You must meet at least 1 of the following criteria to become a ${mainAgentString} for your brokerage:`}
            </p>
            <ul className="dashed spaced">
                <li>
                    You brokered mortgages under a licenced brokerage under the Mortgage Registration Act (MRA) for at least 24 of the past 36 months.  
                </li>
                <li>You have a current Mortgage Broker licence in one of the following provinces:
                    <ul className="dashed indented">
                        <li>Alberta</li>
                        <li>British Columbia</li>
                        <li>Manitoba</li>
                        <li>New Brunswick</li>
                        <li>Ontario</li>
                        <li>Quebec</li>
                        <li>Saskatchewan</li>
                    </ul>
                </li>
                <li>You are exempt from MRA because you brokered mortgages for a federally regulated financial institution.</li>
            </ul>

            <p>Do you meet at least one of these criteria?</p>
        </div>
    </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
          {showRoleConfirmationError &&
            ErrorWithString(errStr)
          }
        </div>
      </div>
    </div>
  );
};
